/** Smallest contiguous replacement preserving equal prefix and suffix. */
export function getTextDiffWindow(previous: string, next: string) {
  let prefix = 0
  while (prefix < previous.length && prefix < next.length && previous[prefix] === next[prefix]) prefix += 1
  let suffix = 0
  while (suffix < previous.length - prefix && suffix < next.length - prefix &&
    previous[previous.length - suffix - 1] === next[next.length - suffix - 1]) suffix += 1
  return { prefix, suffix }
}
